import { Component, Input } from '@angular/core';
import {
    NavController,
    NavParams
} from 'ionic-angular';
import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { RodeoEventSchedule } from '../../../../model/rodeoEventSchedule';
import { DatePipe } from '@angular/common';
import { ReportsService } from '../../../../services/reports.service';
import { PrintService } from '../../../../services/print-service';
import { RunService } from '../../../../services/run.service';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';
import { DateHelperService } from '../../../../services/date-helper';

@Component({
    selector: 'page-announcer-sheets-report',
    templateUrl: 'report-announcer-sheets.html'

})
export class AnnouncerSheetsReport {
    @Input('rodeo') rodeo: Rodeo;

    allRodeoEvent: RodeoEvent = new RodeoEvent();
    allSchedule: RodeoEventSchedule = new RodeoEventSchedule();
    schedule: RodeoEventSchedule;
    schedulesToShow: any[] = [];
    selectedRodeoEvents: any;
    runs: any[] = [];

    runResultArray: any[] = [];
    showStockColumns: boolean;
    roundArray: any[] = [];
    roundOnlyArray: any[] = [];

    selectedRound: number;
    availableRounds: number = 1;

    documentTitle: any;
    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;
    pageBreakEvery: number = 25;
    rowSpacing = 1;

    constructor(private printService: PrintService, private nav: NavController, private navParams: NavParams, private datePipe: DatePipe, private reportService: ReportsService, private runService: RunService, public dateHelper: DateHelperService) {
        if (!this.rodeo)
            this.rodeo = navParams.get('rodeo');

        this.selectedRodeoEvents = navParams.get('selectedRodeoEvents');
        this.schedule = navParams.get('schedule');
        this.selectedRound = navParams.get('selectedRound');
        this.showStockColumns = navParams.get('showStockColumns');
        this.selectedRound = navParams.get('selectedRound');
        this.printing = navParams.get('printing');

        this.allSchedule.name = 'All';

        if (!this.selectedRodeoEvents) {
            this.selectedRodeoEvents = [];
            this.selectedRodeoEvents.push(navParams.get('selectedRodeoEvent'));
        }

        if (!this.schedule) {
            this.schedulesToShow = [];
            this.schedule = navParams.get('schedule');
            this.schedulesToShow.push(this.schedule);
        }

        if (this.schedule && this.schedule.name == 'All')
            this.schedule = this.allSchedule;

        if (navParams.get('pageBreakEvery'))
            this.pageBreakEvery = navParams.get('pageBreakEvery');

        if (navParams.get('rowSpacing')) 
            this.rowSpacing = navParams.get('rowSpacing');

        if (this.selectedRound == undefined && !navParams.get('selectedRound')) {
            this.selectedRound = 1;
        }

        if (this.printing) {
            this.load();
        }
    }

    load() {
        if (!this.printing) {
            this.selectedRodeoEvents = [this.rodeo.rodeoEvents[0]];
        }

        this.updateRodeoEvents();

        this.documentTitle = this.rodeo.name + " - " + (this.selectedRodeoEvents.length == this.rodeo.rodeoEvents.length ? 'All Classes' : this.selectedRodeoEvents[0].displayName) + " - " + this.schedule.name + ' Announcer Sheets';
        this.dataLoaded = true;
    }

    matchRodeoEvents(a, b) {
        return a.id == b.id;
    }

    matchSchedules(a, b) {
        return a.name && b.name && a.name.toLowerCase() == b.name.toLowerCase();
    }

    matchRounds(a, b) {
        return a == b;
    }

    updateRunValue(rodeoEvent, run) {
        if (run.noTime)
            run.announcerValue = "No Time";
        else if (run.turnedOut)
            run.announcerValue = "Turnout";
        else if (this.isRoughStock(rodeoEvent)) {
            run.announcerValue = run.score;
        } else {
            run.announcerValue = (+run.time).toFixed(rodeoEvent.configuration.runs.decimalPlaces);
        }
    }

    updateRodeoEvents() {
        if (this.selectedRodeoEvents == this.allRodeoEvent || this.selectedRodeoEvents.some(x => x == this.allRodeoEvent) || this.selectedRodeoEvents.length == 0) {
            this.selectedRodeoEvents = this.rodeo.rodeoEvents; 
        }
        
        this.schedulesToShow = [];
        this.selectedRodeoEvents.flatMap(x => x.schedules).forEach(rodeoEventSchedule => {
            if (this.schedulesToShow.length == 0 || this.schedulesToShow.filter(x => x.name.toLowerCase() == rodeoEventSchedule.name.toLowerCase()).length == 0)
                this.schedulesToShow.push(rodeoEventSchedule);
        })

        if (!this.schedule
            || this.schedulesToShow.length == 1
            || (this.schedule !== this.allSchedule && this.schedulesToShow.filter(x => x.name.toLowerCase() == this.schedule.name.toLowerCase()).length == 0))
            this.schedule = this.selectedRodeoEvents[0].schedules[0];

        var maxRounds = 1;
        this.selectedRodeoEvents.forEach(rodeoEvent => {
            if (rodeoEvent.rounds > this.availableRounds) {
                this.availableRounds = rodeoEvent.rounds;
            }

            rodeoEvent.schedules.forEach((schedule) => {
                this.runs[schedule.id] = [];

                if (this.schedule && this.schedule !== this.allSchedule && this.schedule.name !== schedule.name)
                    return;

                this.runs[schedule.id] = this.runService.getRuns(this.rodeo, rodeoEvent, schedule, this.selectedRound);

                if (this.runs[schedule.id].length > 0) {
                    this.setAdditionalRunInfo(rodeoEvent, this.selectedRound >= 2 ? schedule.runs : this.runs[schedule.id]);

                    if (this.selectedRound == 0) {
                        // Create map to prevent duplicates of run numbers (specifically for scheduleGroup runs)
                        const runMap = new Map(this.runs[schedule.id].map(run => [run.number, run]));

                        this.runs[schedule.id] = Array.from(runMap.values());
                    }
                }
            });

            if (rodeoEvent.rounds + (rodeoEvent.shortGo ? 1 : 0) > maxRounds) {
                maxRounds = rodeoEvent.rounds + (rodeoEvent.shortGo ? 1 : 0);
            }
        });

        this.roundArray = [];
        this.roundOnlyArray = [];
        for (let i = 1; i <= maxRounds; i++) {
            this.roundOnlyArray.push(i);

            if (this.selectedRound != 0 && this.selectedRound != i)
                continue;

            this.roundArray.push("Rd " + i);

            if (i > 1)
                this.roundArray.push("ToT " + i);

            if (i < maxRounds && this.showStockColumns && this.selectedRound == 0) {
                this.roundArray.push("Stock");
            }
        }

        const allRuns = this.runs.flatMap(x => x);
        if (this.selectedRound == 1
            && (allRuns as RodeoEventRun[]).some(z => z.startingTime != 0 || z.startingScore != 0)) {
            this.roundArray.unshift("In");
        }
    }

    getScheduleDate(rodeoEvent, schedule) {
        let schedules = rodeoEvent.schedules.filter(x => x.name === schedule.name);

        return !schedules[0] ? '' : schedules[0].scheduledDate;
    }

    setAdditionalRunInfo(rodeoEvent: RodeoEvent, runs: any[]) {
        var firstRoundRuns = runs.filter(x => x.round == 1).sort((a, b) => a.number - b.number);

        let rodeoIndex = this.selectedRodeoEvents.indexOf(rodeoEvent);
        this.runResultArray[rodeoIndex] = [];

        const showInColumn = this.selectedRound == 1 && runs.some(x => x.startingScore != 0 || x.startingTime != 0);
        const maxRounds = rodeoEvent.rounds + (rodeoEvent.shortGo ? 1 : 0) + (showInColumn ? 1 : 0);

        let matchingBackNumbers = null;

        if (this.rodeo.backNumberConfigs && this.rodeo.backNumberConfigs.length > 0) {
            matchingBackNumbers = this.rodeo.backNumbers.filter(x => x.eventType == rodeoEvent.eventType);

            if (matchingBackNumbers.length == 0)
                matchingBackNumbers = this.rodeo.backNumbers.filter(x => !x.eventType);
        }

        runs.forEach(run => {
            if (!this.runResultArray[rodeoIndex][run.runIdentifier])
                this.runResultArray[rodeoIndex][run.runIdentifier] = [];

            if (matchingBackNumbers != null) {
                var backNumberObj = matchingBackNumbers.filter(x => (this.rodeo.backNumberConfigs[0].byHorse ? x.horseId == run.horseOneId : x.accountId == run.contestantOneId))[0];
                if (backNumberObj)
                    (run as any).contestantOneBackNumber = backNumberObj.number;

                if (run.contestantTwo != null) {
                    backNumberObj = matchingBackNumbers.filter(x => (this.rodeo.backNumberConfigs[0].byHorse ? x.horseId == run.horseTwoId : x.accountId == run.contestantTwoId))[0];

                    if (backNumberObj)
                        (run as any).contestantTwoBackNumber = backNumberObj.number;
                }
            }
        });

        for (let i = 1; i <= maxRounds; i++) {
            if (this.selectedRound != 0 && this.selectedRound != i)
                continue;

            firstRoundRuns.forEach((firstRoundRun, runIndex) => {
                let run = runs.filter(x => x.runIdentifier == firstRoundRun.runIdentifier && x.round == i)[0];
                let index = 1;

                if (this.selectedRound == 0)
                    index = i > 2 ? i + (this.showStockColumns ? (i - 1) : (i - 2)) : i;

                // If all rounds are selected and current round > 2, we are starting >= round + 1
                // Why? We are pushing 2 additional columns 'Total Rd' (guaranteed) & 'Stock' (potentially)

                // Examples:
                // Round 1: 1
                // Round 2: 2
                // Round 3: 3 + (3 - 2) : 3; Result - 4
                // Round 4: 4 + (4 - 2) : 4; Result - 6

                // if round > 1, showing stock and all rounds
                if (i > 1 && this.showStockColumns && this.selectedRound == 0) {
                    let stockDesc = run && run.livestock && run.livestock.brand !== '' && run.livestock.name !== ''
                        ? run.livestock.brand + ' - ' + run.livestock.name : '';
                    
                    let runIdentifier = run ? run.runIdentifier : firstRoundRun.runIdentifier;

                    // Make sure first column is 'stock' due to stock being pushed LAST in roundOnlyArray (Line 189)
                    this.runResultArray[rodeoIndex][runIdentifier][index] = stockDesc;

                    index++;
                }

                if (run) {
                    if (showInColumn) {
                        this.runResultArray[rodeoIndex][firstRoundRun.runIdentifier][index] = rodeoEvent.configuration.runs.scoreValue ? run.startingScore : run.startingTime;
                        index++;
                    }

                    if (rodeoEvent.configuration.runs.scoreValue) {
                        if (run.turnedOutNotified)
                            this.runResultArray[rodeoIndex][run.runIdentifier][index] = 'DO';
                        else if (run.turnedOut)
                            this.runResultArray[rodeoIndex][run.runIdentifier][index] = 'NNTO';
                        else if (run.noTime)
                            this.runResultArray[rodeoIndex][run.runIdentifier][index] = 'NS';
                        else
                            this.runResultArray[rodeoIndex][run.runIdentifier][index] = run.score;
                    } else {
                        if (run.turnedOutNotified)
                            this.runResultArray[rodeoIndex][run.runIdentifier][index] = 'DO';
                        else if (run.turnedOut)
                            this.runResultArray[rodeoIndex][run.runIdentifier][index] = 'NNTO';
                        else if (run.noTime)
                            this.runResultArray[rodeoIndex][run.runIdentifier][index] = 'NT';
                        else
                            this.runResultArray[rodeoIndex][run.runIdentifier][index] = run.time;
                    }

                    if (i > 1) {
                        if (run.done)
                            this.runResultArray[rodeoIndex][run.runIdentifier][index + 1] = rodeoEvent.configuration.runs.scoreValue ? run.totalScore : run.totalTime;
                        else
                            this.runResultArray[rodeoIndex][run.runIdentifier][index + 1] = '';
                    }
                } else {
                    if (!this.runResultArray[rodeoIndex][firstRoundRun.runIdentifier])
                        this.runResultArray[rodeoIndex][firstRoundRun.runIdentifier] = [];

                    if (showInColumn) {
                        this.runResultArray[rodeoIndex][firstRoundRun.runIdentifier][index] = rodeoEvent.configuration.runs.scoreValue ? run.startingScore : run.startingTime;
                        index++;
                    }

                    this.runResultArray[rodeoIndex][firstRoundRun.runIdentifier][index] = '';

                    if (i > 1) {
                        this.runResultArray[rodeoIndex][firstRoundRun.runIdentifier][index + 1] = '';
                    }
                }
            });
        }
    }

    isRoughStock(rodeoEvent: RodeoEvent) {
        if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding' || rodeoEvent.eventType === 'BarebackRiding')
            return true;
        else
            return false;
    }

    shouldWriteDragLine(rodeoEvent, schedule, run, runIndex) {
        if (rodeoEvent.dragEvery == 0 || run == null || runIndex + 1 >= this.runs[schedule.id].length || (rodeoEvent.eventType != 'BarrelRacing' && rodeoEvent.eventType != 'PoleBending'))
            return false;

        let nextRun = this.runs[schedule.id][runIndex + 1];

        if (rodeoEvent.reverseSecondRound && this.selectedRound == 2 || this.selectedRound > rodeoEvent.rounds) {
            nextRun = run;
            run = this.runs[schedule.id][runIndex + 1];
        }

        let lastDragCount = Math.floor((+run.number - 1) / +rodeoEvent.dragEvery);
        let currentDragCount = Math.floor((+nextRun.number - 1) / +rodeoEvent.dragEvery);

        if (currentDragCount > lastDragCount)
            return true;

        return false;
    }

    shouldWriteBigDragLine(rodeoEvent, schedule, run, runIndex) {
        if (rodeoEvent.dragEvery == 0 || run == null || runIndex + 1 >= this.runs[schedule.id].length || (rodeoEvent.eventType != 'BarrelRacing' && rodeoEvent.eventType != 'PoleBending'))
            return false;

        let nextRun = this.runs[schedule.id][runIndex + 1];

        if (rodeoEvent.reverseSecondRound && this.selectedRound == 2 || this.selectedRound > rodeoEvent.rounds) {
            nextRun = run;
            run = this.runs[schedule.id][runIndex + 1]
        }

        let lastBigDragCount = Math.floor((+run.number - 1) / +rodeoEvent.bigDragEvery);
        let currentBigDragCount = Math.floor((+nextRun.number - 1) / +rodeoEvent.bigDragEvery);

        if (currentBigDragCount > lastBigDragCount)
            return true;

        return false;
    }

    shouldPageBreak(rodeoEvent, schedule, run, runIndex) {
        if (run == null || runIndex + 1 >= this.runs[schedule.id].length)
            return false;

        let nextRun = this.runs[schedule.id][runIndex + 1];

        if (rodeoEvent.reverseSecondRound && this.selectedRound == 2 || this.selectedRound > rodeoEvent.rounds) {
            nextRun = run;
            run = this.runs[schedule.id][runIndex + 1]
        }

        let lastBigDragCount = Math.floor((+run.number - 1) / this.pageBreakEvery);
        let currentBigDragCount = Math.floor(+(nextRun.number - 1)/ this.pageBreakEvery);

        if ((currentBigDragCount > lastBigDragCount))
            return true;

        return false;
    }

    ionViewDidEnter() {
        if (this.printing && this.dataLoaded) {
            setTimeout(() => {
                window.document.title = this.documentTitle;
                window.print();
                this.nav.pop();
            }, 0);
        }
    }

    async print() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        this.nav.push(AnnouncerSheetsReport, {
            rodeo: this.rodeo,
            printing: true,
            selectedRodeoEvents: this.selectedRodeoEvents,
            schedule: this.schedule,
            showStockColumns: this.showStockColumns,
            selectedRound: this.selectedRound,
            pageBreakEvery: this.pageBreakEvery,
            rowSpacing: this.rowSpacing
        }).then(() => { this.popoverActive = false; });
    }

    getHorseAge(birthDate) {
        const birthdate = new Date(birthDate);
        const today = new Date();
        const diffYear = today.getFullYear() - birthdate.getFullYear();
        const diffMonths = today.getMonth() - birthdate.getMonth();
        return `${diffYear}y ${diffMonths}m`;
    }


    download() {
        const report = [];
        const rodeoEvents = this.selectedRodeoEvents;

        rodeoEvents.forEach(rodeoEvent => {
            rodeoEvent.schedules.forEach((schedule) => {
                if (this.schedule && this.schedule.name !== schedule.name)
                    return;

                let runs = this.runs[schedule.id];

                if (runs.length > 0) {
                    runs.forEach((run) => {
                        report.push(this.createReportItem(rodeoEvent, run, run.contestantOne, run.horseOne));
                        if (rodeoEvent.eventType == 'TeamRoping') {
                            report.push(this.createReportItem(rodeoEvent, run, run.contestantTwo, run.horseTwo, 2));
                        }
                    })
                }
            })
            // if (rodeoEvent.runs) {
            //     rodeoEvent.runs.forEach(run => {
            //         report.push(this.createReportItem(rodeoEvent, run, run.contestantOne, run.horseOne));
            //         if (rodeoEvent.eventType == 'TeamRoping') {
            //             report.push(this.createReportItem(rodeoEvent, run, run.contestantTwo, run.horseTwo, 2));
            //         }
            //     });
            // }
        })

        this.reportService.exportToCsv(report, `${this.rodeo.name} - ${this.schedule.name}`);
    }

    rowSpacingChange() {
        if (this.pageBreakEvery * this.rowSpacing > 25) {
            this.pageBreakEvery = Math.round(this.pageBreakEvery = 25 / this.rowSpacing);
        }
    }

    private createReportItem(rodeoEvent, run, contestant, horse, horseNum = 1) {
        let item = {
            "Rodeo Event": `${rodeoEvent.displayName} - ${this.schedule.name} ${this.datePipe.transform(this.schedule.scheduledDate, 'EE M/d h:mm a')}`,
            Place: run.number + run.extraLabel,
            Contestant: contestant ? `${contestant.firstName} ${contestant.lastName}` : '',
            City: contestant ? contestant.city : '',
            State: contestant ? contestant.state : ''
        } as any;

        const isRoughStock = this.isRoughStock(rodeoEvent);
        if (!isRoughStock) {
            item["Horse"] = horse ? horse.name : 'Horse ' + horseNum;
            item["Horse Age"] = horse && horse.birthDate ? this.getHorseAge(horse.birthDate) : '';
            item["Horse Sex"] = horse ? horse.sex : '';
            item["Horse Sire"] = horse && horse.sire ? horse.sire.name : '';
            item["Horse Dam"] = horse && horse.dam ? horse.dam.name : '';
            item["Horse Dam Sire"] = horse && horse.dam && horse.dam.sire ? horse.dam.sire.name : '';
            item["Horse Owner"] = horse && horse.owner ? horse.owner.name : '';
            item["Horse Breeder"] = horse && horse.breeder ? horse.breeder.name : '';
            item["TO"] = run.turnedOut ? 'X' : '';
            item["Time"] = run.turnedOut ? 'TO' : run.time;
        }


        if (isRoughStock) {
            item["Stock #"] = run.livestock ? run.livestock.brand + ' ' + run.livestock.name : '';
            item["Ride"] = run.turnedOut ? 'TO' : run.score;
            item["Stock"] = run.livestock ? run.livestock.brand + ' ' + run.livestock.name : '';
            item["Subtotal"] = run.time
            item["Total"] = run.totaltime
        } else if (rodeoEvent.eventType !== 'BarrelRacing') {
            item["Stock"] = run.livestock ? run.livestock.brand + ' ' + run.livestock.name : '';
            item["Penalty"] = run.penaltyTime;
            item["Total Time"] = run.totalTime;
        }

        return item;
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-announcer-sheets.ts